export default __webpack_public_path__ + "static/media/payment-method.7862c5f5.svg";